<template>
  <div class="imgBox">
    <el-upload action="" drag :auto-upload=false :multiple="max>1" :file-list="imgList" :on-change="imgPreview" list-type="picture-card" accept="image/*" :limit="20" :disabled="delFlag" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :class="[isAdd || disabled ? 'hidden' : '', disabled ? 'readonly' : '']">
    </el-upload>
    <!-- <el-dialog title="图片展示" :visible.sync="dialogVisible" append-to-body center width="1100px" class="imgDialog">
      <img style="max-width:100%;" :src="dialogImageUrl" alt="">
    </el-dialog> -->
    <el-image-viewer v-if="dialogVisible" :on-close="closeViewer" :url-list="lookimgList" />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: { ElImageViewer },

  name: 'uploadImgs',
  props: {
    imgList: {
      type: Array,
      default: function () {
        return []
      }
    },

    max: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lookimgList: [],
      dialogImageUrl: '',
      isAdd: false,
      dialogVisible: false,
      delFlag: false

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.imgList.length == this.max) {
      this.isAdd = true
    }
  },
  methods: {
    // 图片上传
    handleRemove (file, fileList) {
      this.$emit('update:imgList', fileList)
      this.$emit('remove', file)
      if (fileList.length < this.max) {
        this.isAdd = false
      }
      this.lookimgList = []
      fileList.forEach((item, index) => {
        this.$set(this.lookimgList, index, item.url)
      })
    },
    closeViewer () {
      this.dialogVisible = false
    },
    imgPreview (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png|)$/
      if (regex.test(fileName.toLowerCase())) {
        console.log(fileList, 'fileList')
        this.lookimgList = []
        fileList.forEach((item, index) => {
          this.$set(this.lookimgList, index, item.url)
        })
        this.$emit('update:imgList', fileList)
        this.$emit('change', fileList)
        if (fileList.length < this.max) {
          this.isAdd = false
        } else {
          this.isAdd = true
        }
      } else {
        fileList.pop()
        this.$alert('不支持此类型', '系统提示')
        return false
      }
    },
    handlePictureCardPreview (file) {
      if (this.lookimgList.length == 0) {
        this.imgList.forEach((item, index) => {
          this.lookimgList.push(item.url)
        })
        this.lookimgList.forEach((item, index) => {
          if (item == file.url) {
            // this.lookimgList = this.lookimgList.slice(index).concat(this.lookimgList.slice(0, index))
            this.$preview(this.lookimgList, index)
          }
        })
      } else {
        this.lookimgList.forEach((item, index) => {
          if (item == file.url) {
            // this.lookimgList = this.lookimgList.slice(index).concat(this.lookimgList.slice(0, index))
            this.$preview(this.lookimgList, index)
          }
        })
      }
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less' >
.imgBox {
  margin: 22px 10px;
}

.hidden /deep/.el-upload--picture-card {
  display: none;
}
.readonly /deep/.el-upload-list__item-delete {
  display: none;
}
.imgDialog /deep/.el-dialog__body {
  text-align: center;
}
/deep/.el-upload-list--picture-card .el-upload-list__item-actions{
  font-size:30px;
  .el-upload-list__item-delete{
    margin-left: 30px;
  }
}
/deep/.el-upload-dragger{
  background: none;
  width: auto;
  height: 100%;
  border: none;
}
</style>
